<template>
  <div class="overflow-hidden rounded-full">
    <div
      class="
        bg-gray-100
        flex
        justify-center
        items-center
        w-full
        h-full
        font-semibold
        text-vice-teal-600
      "
      v-if="isLoading || !image"
    >
      {{ initials }}
    </div>
    <img class="w-full h-full object-cover" v-else :src="image" :alt="name" />
  </div>
</template>

<script>
import { useImage } from '@vueuse/core';
import { ref, computed, watch } from 'vue';

export default {
  props: {
    image: {
      type: String,
    },
    name: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const imgUrl = ref(props.image);
    const { isLoading } = useImage({ src: imgUrl.value ?? '' });

    const fullName = computed(() => props.name.split(' '));
    const initials = computed(() => {
      const firstInitial = fullName.value[0]?.charAt(0) ?? '';
      const secondInitial = fullName.value[1]
        ? fullName.value[1].charAt(0)
        : fullName.value[0]?.charAt(1) ?? '';
      return `${firstInitial}${secondInitial}`.toUpperCase();
    });

    watch(
      () => props.image,
      (newImage) => {
        imgUrl.value = newImage;
      },
    );

    return {
      isLoading,
      initials,
    };
  },
};
</script>
